{
  "intro": {
    "greeting": "Hola",
    "projects": "Proyectos",
    "contact": "Contacto",
    "me": "Soy"
  }
}